import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { OfflineDerVerifyPage } from '@/features/billing/pages/OfflineDerVerifyPage';
import { offlineDerSearchSchema } from '@/features/billing/types/billing.types';

export const Route = createFileRoute('/_auth/billing/offline-der-verify')({
  validateSearch: offlineDerSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Offline DER Verify">
      <Suspense fallback={<PageLoader />}>
        <OfflineDerVerifyPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
